import React from 'react';
type NordenProps = {
  variant: 'pointing' | 'speechBubble' | 'full' | 'sticker';
  className?: string;
  bubbleText?: string;
};
export const Norden: React.FC<NordenProps> = ({
  variant,
  className = '',
  bubbleText
}) => {
  // This is a placeholder for the Norden mascot
  // In a real implementation, you would use actual images for the mascot
  if (variant === 'pointing') {
    return <div className={`relative ${className}`} data-id="element-427">
        <div className="bg-[#007AFF] rounded-full w-16 h-16 flex items-center justify-center text-white font-bold" data-id="element-428">
          N
        </div>
        <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-[#007AFF] rounded-full flex items-center justify-center" data-id="element-429">
          <div className="w-4 h-4 bg-[#007AFF] transform rotate-45 absolute -top-1" data-id="element-430"></div>
        </div>
      </div>;
  }
  if (variant === 'speechBubble') {
    return <div className={`relative ${className}`} data-id="element-431">
        <div className="bg-[#007AFF] bg-opacity-10 rounded-xl p-3 text-[#007AFF]" data-id="element-432">
          <p className="font-medium" data-id="element-433">{bubbleText || 'Hallo! Ik ben Norden!'}</p>
          <div className="absolute -bottom-2 left-5 w-4 h-4 bg-[#007AFF] bg-opacity-10 transform rotate-45" data-id="element-434"></div>
        </div>
        
      </div>;
  }
  if (variant === 'full') {
    return <div className={`relative flex items-end ${className}`} data-id="element-435">
        <div className="bg-[#007AFF] rounded-full w-24 h-24 flex items-center justify-center text-white font-bold text-2xl" data-id="element-436">
          N
        </div>
        <div className="absolute top-1/2 left-20 w-8 h-8 bg-[#007AFF] rounded-full" data-id="element-437"></div>
        <div className="absolute top-1/4 right-0 w-8 h-8 bg-[#007AFF] rounded-full" data-id="element-438"></div>
      </div>;
  }
  // Sticker variant (small easter egg)
  return <div className={`${className}`} data-id="element-439">
      
    </div>;
};